import React from "react";

interface HookWrapperProps<HookReturnValue> {
  hook: () => HookReturnValue;
}

// Just a component you can pass a hook to and make assertions about it
export default function HookWrapper<T>({ hook: hookProp }: HookWrapperProps<T>) {
  const hook = hookProp();
  return <HookHolder hook={hook} />;
}

interface HookHolderProps<HookReturnValue> {
  hook: HookReturnValue;
}

// If you need to test the behavior of the values/functions returned by a hook, find this
// component in the enzyme wrapper and you can grab them off of the `hook` prop
export function HookHolder<T>(_props: HookHolderProps<T>) {
  return <div />; // This element doesn't matter
}
